import React from 'react';
import { Row, Col, Card, FormGroup } from 'react-bootstrap';
import { set } from 'lodash';
import { usePurchaseOrderState } from '../PurchaseOrderContext';
import { ElementTemplate } from '../TemplateComponent';
import { commonPath } from '../fieldPath';

export function RenderCompanyDetails({ data, pIndex, isProductArchived }) {
  console.log('🚀 ~ RenderCompanyDetails.js:9 ~ RenderCompanyDetails ~ data:', data);
  const { setPurchaseOrderState, purchaseOrderState, disableConditions, fromPreview, isPublicPoPage, poAddEditAccess } = usePurchaseOrderState();

  const handleChange = (value, keyName) => {
    const copyState = purchaseOrderState;
    let locate = '';
    if (keyName.includes('options')) {
      locate = keyName.split('.options');
    } else {
      locate = keyName.split('.value');
    }
    if (locate[0]?.startsWith(`templateJsonSchema[${pIndex}].columns[0][0]`)) {
      copyState.templateJsonSchema[pIndex].columns[1][0].value = value?.email;
      if (copyState.templateJsonSchema[pIndex].columns[1][0].hasError) {
        copyState.templateJsonSchema[pIndex].columns[1][0].hasError.status = false;
      }
    }
    set(purchaseOrderState, `${locate[0]}.hasError.status`, false);
    set(purchaseOrderState, keyName, value);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  return (
    <Card className="listing-card">
      <Card.Header className="px-2 py-2 bgcolor-dark">
        <strong>{data?.label}</strong>
      </Card.Header>
      <Card.Body className="py-4">
        <Row className="span_font_size">
          {data?.columns.map((column, index) => {
            return (
              <Col lg={6} key={index}>
                {column.map((col, i) => {
                  return (
                    col?.enable && (
                      <FormGroup key={i}>
                        <ElementTemplate
                          {...col}
                          keys={col?.key}
                          onChange={handleChange}
                          error={col?.hasError}
                          requiredField={col?.required}
                          value={col?.value}
                          isProductArchived={isProductArchived}
                          disable
                          onlyRead={col.id === '4' || col.id === '3'}
                          path={
                            col?.key === 'Check_Boxes' ? commonPath(pIndex, index, i).COMPANY_DETAILS_CHECKBOX : commonPath(pIndex, index, i).COMPANY_DETAILS
                          }
                        />
                      </FormGroup>
                    )
                  );
                })}
              </Col>
            );
          })}
        </Row>
      </Card.Body>
    </Card>
  );
}

export default RenderCompanyDetails;
